module.exports = __webpack_public_path__ + "static/media/fig_23a.e99be3bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_23a.jpg
// module id = 658
// module chunks = 0